import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(
  {
    container: {
      overflow: "visible !important"
    },
    typo: {
      fontSize: "inherit",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": ({ line }) => line || 1,
      "-webkit-box-orient": "vertical"
    }
  },
  { name: "BackstageOverflowTooltip" }
);
function OverflowTooltip(props) {
  const classes = useStyles(props);
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      title: props.title ?? (props.text || ""),
      placement: props.placement,
      children: /* @__PURE__ */ jsx(Typography, { className: classes.typo, variant: "inherit", children: props.text })
    }
  );
}

export { OverflowTooltip };
//# sourceMappingURL=OverflowTooltip.esm.js.map
